import { SKILLS } from '../../database/database';
import { Skill } from '../../models/skill';
import style from './skills.module.css';

function SkillItem({ skill }: { skill: Skill }) {
  return (
    <div className={style.skill}>
      <img src={skill.icon} alt={skill.name} />
      <h3>{skill.name}</h3>
    </div>
  );
}

export default function Skills() {
  return (
    <div className={style.skills} id="skills">
      <h2>My Skills</h2>
      <div>
        {SKILLS.map((skill) => (
          <SkillItem key={skill.id} skill={skill} />
        ))}
      </div>
    </div>
  );
}
